import { Book } from '../../../types';

export const filterBooks = (
  booksManyBlock: Book[],
  searchTerm: string,
  searchMode: 'title' | 'author' | 'subject',
) => {
  const lowerCaseSearchTerm = searchTerm.trim().toLowerCase();

  return booksManyBlock.filter((book) => {
    if (searchMode === 'title') {
      return book.title.trim().toLowerCase().includes(lowerCaseSearchTerm);
    } else if (searchMode === 'author') {
      return book.author.trim().toLowerCase().includes(lowerCaseSearchTerm);
    } else if (searchMode === 'subject' && book.category) {
      return book.category
        .map((cat) => cat.trim().toLowerCase())
        .includes(lowerCaseSearchTerm);
    }
    return false;
  });
};
